<app-abandoned-reservation-header
  [user]="user"
  [translationType]="'FLIGHTS'">
</app-abandoned-reservation-header>
<app-abandoned-reservation-body [hasImage]="hasImage">
  <app-image
    image
    [type]="typeImage"
    [src]="reservationImageByDestination"
    [maxHeight]="181"
    [borderRadius]="8"
    (errorImage)="errorImage($event)"
    >
  </app-image>
  <ng-container content>
    <div class="extraRetargetCont">
      <h2>{{reservation?.TravelExtra?.TravelExtraName}}</h2>
      <div class="extraRetargetCont__info">
        <p><strong>{{'SEARCH_MODULE.LOCATION_SEARCH.DESTINATION' | transloco}}:</strong> {{reservation?.DestinationCode | placeName | async | capitalizeAll}}</p>
        <p><strong>{{'DATE' | transloco}}:</strong> {{reservation?.UsageDate | date: 'd/M/yy'}}</p>
        <p><strong>{{'TYPE' | transloco}}:</strong> {{reservation?.TravelExtra?.TravelExtraType}}</p>
      </div>
    </div>
    <app-abandoned-reservation-actions
      [itineraryId]="itinerary?.Id"
      [reservationType]="reservationType"
      [userId]="user?.id"
      [isMobile]="isMobile"
      [isLoadingCancellation]="isLoadingCancellation"
      (cancelEvent)="cancelEvent.emit(itinerary?.Id)">
    </app-abandoned-reservation-actions>
  </ng-container>
</app-abandoned-reservation-body>